/**
 * 机场三字码归一化工具。
 *
 * 机场约束以归一化后的三字码为键存储，所有读取端必须走同一入口。
 * 若写入端归一化而读取端用原始值，脏数据（小写、带空格）会让
 * `if (airportConstraints[code])` 这类宵禁校验闸门静默落空——不报错，直接跳过校验。
 */

export function normalizeAirportCode(value) {
    return String(value ?? "").trim().toUpperCase();
}

/**
 * 按归一化后的三字码取机场约束，取不到返回 null。
 */
export function getAirportConstraint(airportConstraints, airportCode) {
    const code = normalizeAirportCode(airportCode);
    if (!code || !airportConstraints) {
        return null;
    }
    return airportConstraints[code] || null;
}
